import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import pensionLogo from "../../../../../../assets/images/pensionReturnPiller.png";
import { formatRoundedCHF } from "../../../../../../utility/helper";
import { useSelector } from "react-redux";

const donutColors = ["#FF85B6", "#0b7be4", "rgb(233, 225, 115)"];

const CombinedCharts = ({ graphROI }) => {
  const [pieChartData, setPieChartData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const { currency } = useSelector((state) => state.user);

  useEffect(() => {
    if (graphROI) {
      setPieChartData([
        { name: "1st Pillar", value: graphROI?.p1 },
        { name: "2nd Pillar", value: graphROI?.p2 },
        { name: "3rd Pillar", value: graphROI?.p3 },
      ]);
    }
  }, [graphROI]);

  return (
    <div className="md:flex gap-4 md:space-y-0 space-y-5">
      <div className="border border-lightPrimary/40 dark:border-info/40 p-5 md:w-[50%] dark:bg-custom-radial bg-white">
        <h2 className="text-2xl text-lightPrimary dark:text-primary-gradient font-semibold text-center">
          Pension
        </h2>
        <ResponsiveContainer height={400}>
          <PieChart>
            <Tooltip
              cursor={{ fill: "none" }}
              content={({ payload }) => {
                if (!payload || payload.length === 0) return null;

                return (
                  <div className="p-3 bg-white rounded-lg shadow-md text-gray-800">
                    <div className="flex gap-2">
                      <strong className="m-0 text-gray-800">Name:</strong>
                      <p className="text-gray-800">
                        {payload[0]?.payload.name}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <strong className="m-0 text-gray-800">Value:</strong>
                      <p className="text-gray-800">
                        {formatRoundedCHF(payload[0]?.payload.value)}{" "}
                        {currency ? currency : ""}
                      </p>
                    </div>
                  </div>
                );
              }}
            />
            <Pie
              data={pieChartData}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={90}
              paddingAngle={2}
              dataKey="value"
              onMouseEnter={(_, index) => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
              activeIndex={activeIndex}
              activeShape={{ outerRadius: 100 }}
            >
              {pieChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={donutColors[index]} />
              ))}
            </Pie>

            <Legend
              verticalAlign="bottom"
              align="center"
              content={() => (
                <div className="flex justify-center gap-4 mt-2">
                  {pieChartData.map((entry, index) => (
                    <div key={index} className="flex items-center gap-1">
                      <div
                        style={{
                          width: 12,
                          height: 12,
                          backgroundColor: donutColors[index],
                          borderRadius: 2,
                        }}
                      ></div>
                      <span className="text-lightPrimary dark:text-primary-gradient text-sm">
                        {entry.name}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="border border-lightPrimary/40 dark:border-info/40 p-5 md:w-[50%] dark:bg-custom-radial bg-white">
        <img
          src={pensionLogo}
          alt="Pension Logo"
          className="w-full mx-auto h-full"
        />
      </div>
    </div>
  );
};

export default CombinedCharts;
